import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=37501dc0&scoped=true&"
import script from "./EventItem.vue?vue&type=script&lang=js&"
export * from "./EventItem.vue?vue&type=script&lang=js&"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=37501dc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37501dc0",
  null
  
)

export default component.exports